import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = { class: "col-md-6" }
const _hoisted_7 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_8 = {
  class: "tab-content",
  id: "myTabContent"
}
const _hoisted_9 = {
  class: "tab-pane fade show active p-10",
  id: "home-tab-pane",
  role: "tabpanel",
  tabindex: "0"
}
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "border border-primary mb-10" }
const _hoisted_12 = {
  class: "row d-flex align-items-center justify-content-between fw-bold py-2",
  style: {"background-color":"#0a59a4"}
}
const _hoisted_13 = { class: "col-md-5" }
const _hoisted_14 = { class: "d-flex float-end" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = { class: "col-md-5" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = { class: "col-md-2" }
const _hoisted_19 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_20 = ["onUpdate:modelValue"]
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_23 = ["onUpdate:modelValue"]
const _hoisted_24 = { class: "col-md-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "col-md-12 mt-3" }
const _hoisted_27 = { class: "d-flex align-items-center" }
const _hoisted_28 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Field = _resolveComponent("Field")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        onSubmit: _ctx.updateDemandePrix,
        "validation-schema": _ctx.demandePrixSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[3] || (_cache[3] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                  _createTextVNode(" Fournisseur "),
                  _createElementVNode("span", { class: "text-danger" }, "*")
                ], -1)),
                _createVNode(_component_Field, {
                  name: "fournisseur",
                  value: _ctx.formData.fournisseur
                }, {
                  default: _withCtx(({ field, errorMessage }) => [
                    _createVNode(_component_Multiselect, {
                      options: _ctx.fournisseurOptions,
                      searchable: true,
                      "track-by": "value",
                      label: "label",
                      modelValue: _ctx.formData.fournisseur,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.fournisseur) = $event)),
                      "value-prop": "value",
                      object: true,
                      placeholder: "Sélectionner le fournisseur",
                      class: _normalizeClass({ 'is-invalid': errorMessage }),
                      onChange: field.onChange
                    }, null, 8, ["options", "modelValue", "class", "onChange"]),
                    _createVNode(_component_ErrorMessage, {
                      name: "fournisseur",
                      class: "invalid-feedback"
                    })
                  ]),
                  _: 1
                }, 8, ["value"])
              ])
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _cache[4] || (_cache[4] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Date de mouvement", -1)),
                _createVNode(_component_Field, {
                  name: "dateDdp",
                  type: "date",
                  modelValue: _ctx.formData.dateDdp,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.dateDdp) = $event)),
                  class: "form-control shadow-none fs-md-15 text-black"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "col-md-7" }, [
                        _createElementVNode("h3", { class: "fs-4 text-white" }, "Produit")
                      ], -1)),
                      _createElementVNode("div", _hoisted_13, [
                        _createElementVNode("div", _hoisted_14, [
                          _createElementVNode("button", {
                            class: _normalizeClass(["default-btn me-20 transition border-0 fw-medium text-white pt-2 pb-2 ps-8 pe-8 rounded-1 fs-md-13 fs-lg-14 bg-success", { 'cursor-not-allowed': _ctx.isDisable }]),
                            type: "button",
                            disabled: _ctx.isDisable,
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addRowProduit()))
                          }, _cache[5] || (_cache[5] = [
                            _createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1),
                            _createTextVNode(" Ajout un produit ")
                          ]), 10, _hoisted_15)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _cache[8] || (_cache[8] = _createElementVNode("div", { class: "row d-flex align-items-center justify-content-between mt-10" }, [
                      _createElementVNode("div", { class: "col-md-5" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Produit "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
                          _createTextVNode(" Quantité "),
                          _createElementVNode("span", { class: "text-danger" }, "*")
                        ])
                      ]),
                      _createElementVNode("div", { class: "col-md-3" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Prix Unitaire ")
                      ]),
                      _createElementVNode("div", { class: "col-md-2" }, [
                        _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Action")
                      ])
                    ], -1)),
                    _cache[9] || (_cache[9] = _createElementVNode("hr", { class: "mt-0" }, null, -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produits, (produit, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "row",
                        key: index
                      }, [
                        _createElementVNode("div", _hoisted_16, [
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_Multiselect, {
                              options: _ctx.produitOptions,
                              searchable: true,
                              "track-by": "value",
                              label: "label",
                              modelValue: produit.produit,
                              "onUpdate:modelValue": ($event: any) => ((produit.produit) = $event),
                              placeholder: "Sélectionner le produit",
                              onSelect: ($event: any) => (_ctx.selectProd(produit.produit, produit))
                            }, null, 8, ["options", "modelValue", "onUpdate:modelValue", "onSelect"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((produit.qtite) = $event),
                              class: _normalizeClass(_ctx.valideteRowProduit(produit.qtite)
                                                    ? 'form-control shadow-none fs-md-15 text-black is-invalid '
                                                    : 'form-control shadow-none fs-md-15 text-black '
                                                    ),
                              placeholder: "Entrer la quantité"
                            }, null, 10, _hoisted_20), [
                              [_vModelText, produit.qtite]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_21, [
                          _createElementVNode("div", _hoisted_22, [
                            _withDirectives(_createElementVNode("input", {
                              type: "number",
                              "onUpdate:modelValue": ($event: any) => ((produit.prixUnitaireProduit) = $event),
                              class: "form-control shadow-none fs-md-15 text-black",
                              placeholder: "Prix unitaire",
                              step: "0.01"
                            }, null, 8, _hoisted_23), [
                              [_vModelText, produit.prixUnitaireProduit]
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("button", {
                            class: "btn btn-danger transition border-0 pb-2 ps-8 pe-8",
                            type: "button",
                            onClick: ($event: any) => (_ctx.removeRowProduit(index))
                          }, _cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "fa fa-trash-o lh-1 me-1 position-relative top-2" }, null, -1)
                          ]), 8, _hoisted_25)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("button", {
                class: _normalizeClass(["btn btn-success me-3", { 'cursor-not-allowed': _ctx.isDisable }]),
                type: "submit",
                disabled: _ctx.isDisable
              }, " Modifier la demande ", 10, _hoisted_28),
              _createVNode(_component_router_link, {
                to: "/demandes-prix/liste-demande-prix",
                class: "btn btn-danger"
              }, {
                default: _withCtx(() => _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fa fa-times lh-1 me-1 position-relative top-2" }, null, -1),
                  _createElementVNode("span", { class: "position-relative" }, null, -1),
                  _createTextVNode(" Annuler ")
                ])),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}